import { USERS_SERVICE } from "@/services/users.service.js";
import router from '@/router/index';
import { isAdmin, isCoach } from "@/helpers/utils.js";

const user = JSON.parse(localStorage.getItem('user'));
const state = user
    ? { status: { loggedIn: true }, user, processTask: undefined, getUsersOutput: {}, postUserOutput: false, putUserOutput: false, getUserByIdOutput: {}, requestConfirmTokenOutput: {}, deleteUserOutput: {} }
    : { status: {}, user: null, processTask: undefined, getUsersOutput: {}, postUserOutput: false, putUserOutput: false, getUserByIdOutput: {}, requestConfirmTokenOutput: {}, deleteUserOutput: {} };

const actions = {
    login({ dispatch, commit }, { username, password }) {
        dispatch('alert/clear', null, { root: true });
        commit('loginRequest', { username });
        
        USERS_SERVICE.login(username, password)
            .then(
                user => {
                    if(!isAdmin(user) && !isCoach(user))
                    {
                        commit('loginFailure');                
                        dispatch('alert/error', "Unauthorized access", { root: true });
                    }
                    else
                    {
                        commit('loginSuccess', user);
                        router.push('/');
                    }
                },
                error => {
                    commit('loginFailure');                
                    dispatch('alert/error', error, { root: true });
                }

            );
    },
    updatePassword({ dispatch, commit }, password) {
        dispatch('alert/clear', null, { root: true });
        commit('updatePasswordRequest');
        
        USERS_SERVICE.updatePassword(password)
            .then(
                output => {
                    commit('updatePasswordSuccess', output);
                },
                error => {
                    commit('updatePasswordFailure', user);                
                    dispatch('alert/error', error, { root: true });

                }

            );
    },
    requestLinkPassword({ dispatch, commit }, email) {
        dispatch('alert/clear', null, { root: true });
        commit('linkRequest');

        USERS_SERVICE.requestLink(email)
            .then(
                output => {
                    commit('linkSuccess');
                },
                error => {
                    commit('linkFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    resetPassword({ dispatch, commit }, {username, password, token}) {
        dispatch('alert/clear', null, { root: true });
        commit('resetPasswordRequest');

        USERS_SERVICE.resetPassword(username, password, token)
            .then(
                output => {
                    commit('resetPasswordSuccess');
                },
                error => {
                    commit('resetPasswordFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    confirmAccount({ dispatch, commit }, {username, password, token}) {
        dispatch('alert/clear', null, { root: true });
        commit('confirmAccountRequest');

        USERS_SERVICE.confirmAccount(username, password, token)
            .then(
                output => {
                    commit('confirmAccountSuccess');
                },
                error => {
                    commit('confirmAccountFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    logout({ dispatch, commit }) {
        dispatch('alert/clear', null, { root: true });
        commit('logout');

        USERS_SERVICE.logout();
    },
    //Service to get orders
    getUsers({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getUsersRequest');

        USERS_SERVICE.getUsers(queryParams)
            .then(
                output => {
                    commit('getUsersSuccess', output);
                },
                error => {
                    commit('getUsersFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    //Service to create users
    postUser({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('postUserRequest');
        
        USERS_SERVICE.postUser(input)
            .then(
                output => {
                    commit('postUserSuccess', output);
                },
                error => {
                    commit('postUserFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    //Service to update users
    putUser({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('putUserRequest');

        USERS_SERVICE.putUser(input)
            .then(
                output => {
                    commit('putUserSuccess', output);
                },
                error => {
                    commit('putUserFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    //Service to get user details
    getUserById({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getUserByIdRequest');

        USERS_SERVICE.getUserById(queryParams)
            .then(
                output => {
                    commit('getUserByIdSuccess', output);
                },
                error => {
                    commit('getUserByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    //Service to get user details
    requestConfirmToken({ dispatch, commit }, username) {
        dispatch('alert/clear', null, { root: true });
        commit('requestConfirmTokenRequest');

        USERS_SERVICE.requestConfirmToken(username)
            .then(
                output => {
                    commit('requestConfirmTokenSuccess', output);
                },
                error => {
                    commit('requestConfirmTokenFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    // Delete user
    deleteUser({ dispatch, commit }, userId) {
        dispatch('alert/clear', null, { root: true });
        commit('deleteUserRequest');

        USERS_SERVICE.deleteUser(userId)
            .then(
                output => {
                    commit('deleteUserSuccess', output);
                },
                error => {
                    commit('deleteUserFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    // updateUserPassword
    updateUserPassword({ dispatch, commit }, payload) {
        dispatch('alert/clear', null, { root: true });
        commit('updateUserPasswordRequest');

        USERS_SERVICE.updateUserPassword(payload)
            .then(
                output => {
                    commit('updateUserPasswordSuccess', output);
                },
                error => {
                    commit('updateUserPasswordFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};

const mutations = {
    /* Login */
    loginRequest(state, user) {
        state.status = { loggingIn: true };
        state.user = user;
    },
    loginSuccess(state, user) {
        state.status = { loggedIn: true };
        state.user = user;

        // login successful if there's a jwt token in the response
        if (user && user.data && user.data.accessToken) {
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            localStorage.setItem('user', JSON.stringify(user));
        }
    },
    loginFailure(state) {
        state.status = {};
        state.user = null;
    },
    /* Update password */
    updatePasswordRequest(state) {
        state.processTask = null;
    },
    updatePasswordSuccess(state) {
        state.processTask = true;
    },
    updatePasswordFailure(state) {
        state.processTask = false;
    },
    /* Request link */
    linkRequest(state) {
        state.processTask = undefined;
    },
    linkSuccess(state) {
        state.processTask = true;
    },
    linkFailure(state) {
        state.processTask = false;
    },
    /* Reset password */
    resetPasswordRequest(state) {
        state.processTask = null;
    },
    resetPasswordSuccess(state) {
        state.processTask = true;
    },
    resetPasswordFailure(state) {
        state.processTask = false;
    },
    /* Confirm account */
    confirmAccountRequest(state) {
        state.processTask = null;
    },
    confirmAccountSuccess(state) {
        state.processTask = true;
    },
    confirmAccountFailure(state) {
        state.processTask = false;
    },
    /* */
    logout(state) {
        state.status = {};
        state.user = null;

        localStorage.removeItem('user');
        localStorage.removeItem('locale');

        router.go('/login'); // Force all modules to reset state
    },
    //getUsers
    getUsersRequest(state) {
    },
    getUsersSuccess(state, output) {
        state.getUsersOutput = output;
    },
    getUsersFailure(state) {
        state.getUsersOutput = false;
    },
    //getUserById
    getUserByIdRequest(state) {
    },
    getUserByIdSuccess(state, output) {
        state.getUserByIdOutput = output;
    },
    getUserByIdFailure(state) {
        state.getUserByIdOutput = false;
    },
    //postUser
    postUserRequest(state) {
        state.postUserOutput = null;
    },
    postUserSuccess(state, output) {
        state.postUserOutput = true;
    },
    postUserFailure(state) {
        state.postUserOutput = false;
    },
    //putUser
    putUserRequest(state) {
        state.putUserOutput = null;
    },
    putUserSuccess(state, output) {
        state.putUserOutput = true;
    },
    putUserFailure(state) {
        state.putUserOutput = false;
    },
    //requestConfirmToken
    requestConfirmTokenRequest(state) {
        state.requestConfirmTokenOutput = null;
    },
    requestConfirmTokenSuccess(state, output) {
        state.requestConfirmTokenOutput = true;
    },
    requestConfirmTokenFailure(state) {
        state.requestConfirmTokenOutput = false;
    },
    //deleteUser
    deleteUserRequest(state) {
        state.deleteUserOutput = null;
    },
    deleteUserSuccess(state, output) {
        state.deleteUserOutput = true;
    },
    deleteUserFailure(state) {
        state.deleteUserOutput = false;
    },
    // updateUserPassword
    updateUserPasswordRequest(state) {
        state.processTask = null;
    },
    updateUserPasswordSuccess(state) {
        state.processTask = true;
    },
    updateUserPasswordFailure(state) {
        state.processTask = false;
    },
};

export const users = {
    namespaced: true,
    state,
    actions,
    mutations
};